import React from 'react';
import { Route } from 'react-router-dom';
import ProgramResourcesPanel, { ResourceDialog } from '../ProgramResources';
import CorrelationsPanel from './CorrelationsPanel';
import ProgramImagesPanel from './ProgramImagesPanel';
import ProgramInformationSection from './ProgramInformationSection';
import ProgramSettingsPanel from './ProgramSettingsPanel';
import QuestionBankFiltersPanel from './QuestionBankFiltersPanel';
import StoreOrderUrlsPanel from './StoreOrderUrlsPanel';

// The edit page's sections as child routes, under the page on both mounts (ContentView and
// admin/ProgramsPage). Paths match editSections.
const programEditRoutes = (
  <>
    <Route index element={<ProgramInformationSection />} />
    <Route element={<ProgramSettingsPanel />} path="settings" />
    <Route element={<CorrelationsPanel />} path="correlations" />
    <Route element={<StoreOrderUrlsPanel />} path="store-urls" />
    <Route element={<ProgramImagesPanel />} path="images" />
    <Route element={<QuestionBankFiltersPanel />} path="question-bank" />
    <Route element={<ProgramResourcesPanel />} path="resources">
      <Route element={<ResourceDialog />} path="new" />
      <Route element={<ResourceDialog />} path=":resourceId/edit" />
    </Route>
  </>
);

export default programEditRoutes;
